var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 120,
    viewBox: "0 0 165 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.755 1L46.9087 59.8463L105.755 118.693L164.601 59.8463L105.755 1ZM96.6171 74.7079V61.4716H107.253L115.317 73.2177C116.233 74.5618 116.691 75.4092 116.691 75.7598C116.691 76.3052 116.194 76.6559 115.201 76.8117V77.7467H129.635V76.8117C128.719 76.7533 127.94 76.4513 127.297 75.9059C126.674 75.341 125.681 74.0943 124.317 72.1658L116.574 61.1502C123.801 60.0398 127.414 56.2316 127.414 49.7254C127.414 47.8164 127.054 46.0243 126.333 44.3491C125.573 42.6154 124.424 41.2421 122.885 40.2292C121.561 39.3526 120.002 38.739 118.21 38.3883C116.438 38.0377 114.032 37.8624 110.993 37.8624H86.0398V38.7974C86.741 38.9922 87.228 39.2454 87.5007 39.5571C87.7734 39.8688 87.9098 40.3266 87.9098 40.9304V74.7079C87.9098 75.2923 87.7734 75.7403 87.5007 76.052C87.228 76.3637 86.741 76.6169 86.0398 76.8117V77.7467H98.4872V76.8117C97.8054 76.6364 97.3184 76.3929 97.0262 76.0812C96.7535 75.7501 96.6171 75.2923 96.6171 74.7079ZM110.058 54.8972H96.6171V44.4367H110.058C112.084 44.4367 113.486 44.4952 114.266 44.612C115.064 44.7094 115.814 44.9529 116.515 45.3425C117.996 46.1412 118.736 47.5827 118.736 49.667C118.736 51.7513 117.996 53.1928 116.515 53.9914C115.834 54.3615 115.084 54.605 114.266 54.7219C113.447 54.8388 112.045 54.8972 110.058 54.8972Z",
    fill: "#081E56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2139 116.211L76.2139 96.2114",
    stroke: "#081E56",
    strokeWidth: 9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0098 103.008L63.0098 83.0078",
    stroke: "#081E56",
    strokeWidth: 9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8062 89.8041L49.8062 69.8041",
    stroke: "#081E56",
    strokeWidth: 9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39893 63.3967L62.7959 3.99976",
    stroke: "#081E56",
    strokeWidth: 9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6025 76.6003L75.9995 17.2034",
    stroke: "#081E56",
    strokeWidth: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo-blue.aa2feba092fb8858168efa64eec31123.svg";
export { ForwardRef as ReactComponent };